<template>
    <!-- 文化资讯 -->
    <div class="information">
        <BasePage ref="basePage">
            <template scope="{item}">
                <div class="item_box" @click="toDetail(item)">
                    <el-image class="item_img" :src="item.image">
                        <div slot="placeholder" class="image_slot">
                            <i class="el-icon-loading"></i>
                        </div>
                    </el-image>
                    <div class="item_info">
                        <div class="item_title ellipsis">{{item.title}}</div>
                        <div class="bot">
                            <span style="margin-right:auto">浏览 {{0}}</span>
                            <!-- <svg-icon icon-class="comment" class-name="card-panel-icon" /> -->
                            <i class="el-icon-star-off card-panel-icon"  />
                            <span style="margin-right:16px">{{item.scs}}</span>
                            <svg-icon icon-class="thumb" class-name="card-panel-icon" />
                            <span>{{item.dzs}}</span>
                        </div>
                        <div class="item_footer">
                            <el-image class="item_footer_icon" :src="item.venueLogo"  >
                            </el-image>
                            <span style="margin-right:auto">{{item.venueName}}</span>
                            <span>{{item.createTime}}</span>
                        </div>
                    </div>
                </div>
            </template>
        </BasePage>
    </div>
</template>

<script>
import BasePage from '@c/BasePage';
export default {
    name: 'information',
    components: {
        BasePage
    },
    data () {
        return {

        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.basePage.loadImage(to.query.id)
        next()
    },
    methods: {
        toDetail(item) {
            if (item.linkurl) {
                window.open(item.linkurl)
            } else {
                this.$router.push('/information/detail/' + item.id)
            }
            
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.information {
    background: #f8f8f8;
    .item_box {
        width: 285px;
        margin: 0 20px 20px 0;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        transition: box-shadow .4s,transform .4s;
        &:hover {
            transform: translateY(-2%);
            box-shadow: 1px 1px 10px 2px #ccc;

        }
        &:nth-child(4n) {
            margin-right: 0;
        }
        .item_img {
            width: 100%;
            height: 132px;
            object-fit: cover;
            ::v-deep .el-image__inner {
               object-fit: cover; 
            }
        }
        .image_slot {
            text-align: center;
            padding-top: 50px;
            font-size: 30px;
        }
        .item_info {
            padding: 18px;
            line-height: 1;
        }
        .item_title {
            font-size: 18px;
            color: #000;
        }
        .bot {
            display: flex;
            align-items: center;
            color: #c0c0c0;
            margin: 15px 0 25px;
        }
        .item_footer {
            font-size: 14px;
            display: flex;
            align-items: center;
            color: #777;
        }
        .item_footer_icon {
            width: 32px;
            height: 32px;
            margin-right: 7px;
            overflow: hidden;
            border-radius: 50%;
            ::v-deep {
                .el-image__error {
                    font-size: 12px;
                }
            }
        }
        .card-panel-icon {
            font-size: 16px;
            margin-right: 7px;
        }
    }
}
</style>